import { motion } from "framer-motion";
import { FileText, ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/site";

export default function PriceGuide() {
  return (
    <section id="price-guide" className="border-t border-zinc-800 py-24 lg:py-32" data-testid="price-guide-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.4 }}
          className="max-w-2xl"
        >
          <p className="font-mono-industrial text-xs font-semibold uppercase tracking-[0.25em] text-orange-500">
            Honest numbers
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">
            Price Guide
          </h2>
          <p className="mt-6 text-base leading-relaxed text-zinc-400">
            Guide only — every property is different. Every job gets a{" "}
            <span className="font-semibold text-white">free written quote</span> before work
            starts, so the price you see is the price you pay.
          </p>
        </motion.div>

        <div className="mt-12 grid gap-4 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.3, delay: i * 0.04 }}
              className="flex items-center justify-between border border-zinc-800 border-l-4 border-l-orange-600 bg-zinc-950 p-6"
              data-testid={`price-row-${s.id}`}
            >
              <span className="font-display text-lg font-bold tracking-tight text-white">{s.name}</span>
              <span className="font-mono-industrial text-sm font-semibold uppercase tracking-wider text-orange-500" data-testid={`price-value-${s.id}`}>
                {s.price}*
              </span>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.35 }}
          className="mt-10 flex flex-col items-start justify-between gap-6 border border-zinc-800 bg-zinc-900 p-8 sm:flex-row sm:items-center"
          data-testid="price-guide-cta"
        >
          <div className="flex items-start gap-4">
            <FileText className="mt-1 h-6 w-6 shrink-0 text-orange-500" />
            <p className="text-sm leading-relaxed text-zinc-400">
              *Indicative starting points only. Final pricing depends on the site, materials
              and access — locked in with your free written quote.
            </p>
          </div>
          <a
            href="#quote"
            data-testid="price-guide-quote-button"
            className="inline-flex shrink-0 items-center gap-2 border border-orange-600 bg-orange-600 px-8 py-4 font-bold uppercase tracking-wider text-white transition-colors duration-150 hover:bg-orange-500"
          >
            Get my quote <ArrowRight className="h-5 w-5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
